import { put, call } from 'redux-saga/effects';
import axios from 'axios';
import * as actions from '../actions';
import { validateNRIC } from '../../api/accounts';

export function* fetchNRICSessionSaga(action) {
    try {
        const response = yield call(validateNRIC, action.nricNo, action.sessionId);
        // Initialize token dependencies
        axios.defaults.headers.common.Authorization = `Bearer ${response.data.data.token}`;
        localStorage.setItem('credentials', response.data.data);
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('refreshToken', response.data.data.refreshToken);
        localStorage.setItem('sessionTime', response.data.data.sessionTime);

        yield put(actions.onCheckNRICSessionSuccess(response.data.data));
    } catch (error) {
        yield put(actions.onCheckNRICSessionFailed(error.response.data));
    }
}
